import { ReactElement } from 'react';
import { Card, Slider } from 'antd';
import { styled } from 'styled-components';
import { PlayerBlock, SliderRow, TimeLabel } from './AudioPlayer.style';
import formatTime from '../../utils/formatTime';
import calculateProgress from '../../utils/calculateProgress';
import PlayPauseButton from './PlayPauseButton';
import VolumeControl from './VolumeControl';
import PlaybackRateControl from './PlaybackRateControl';
import { UseAudioPlayerReturn } from '../../hooks/useAudioPlayer';

const StyledSlider = styled(Slider)`
  flex: 1;
`;

interface Props {
  duration: number | null;
  audioPlayer: UseAudioPlayerReturn;
}

const AudioPlayer = ({ duration, audioPlayer }: Props): ReactElement => {
  const {
    audioRef,
    audioSrc,
    currentTime,
    volume,
    isPlaying,
    playbackRate,
    seek,
    setVolume,
    togglePlayPause,
    setPlaybackRate,
  } = audioPlayer;

  return (
    <Card size='small'>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption -- 録音音声のためキャプション不要 */}
      <audio ref={audioRef} src={audioSrc} />
      <PlayerBlock>
        <PlayPauseButton isPlaying={isPlaying} onClick={togglePlayPause} />
        <SliderRow>
          <TimeLabel>{formatTime(currentTime)}</TimeLabel>
          <StyledSlider
            value={duration !== null ? calculateProgress(currentTime, duration) : 0}
            onChange={seek}
            disabled={duration === null || duration === 0}
          />
          <TimeLabel>{duration !== null ? formatTime(duration) : '不明'}</TimeLabel>
        </SliderRow>
        <VolumeControl volume={volume} onChange={setVolume} />
        <PlaybackRateControl currentRate={playbackRate} onRateChange={setPlaybackRate} />
      </PlayerBlock>
    </Card>
  );
};

export default AudioPlayer;
